import { render } from "./UpcomingRounds.vue?vue&type=template&id=463da194&scoped=true"
import script from "./UpcomingRounds.vue?vue&type=script&lang=js"
export * from "./UpcomingRounds.vue?vue&type=script&lang=js"

import "./UpcomingRounds.vue?vue&type=style&index=0&id=463da194&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463da194"]])

export default __exports__